import {put} from 'redux-saga/effects';
import {uiActions} from "../../actions";
import {Workers} from "../../../../setup/typedefs";

export function* popup({payload}: Workers){
  yield put(uiActions.fillPopupData(payload));
  yield put(uiActions.popupOpen());
}
